import { ModalProps } from "antd/lib/modal/Modal";
import { Button, Col, Input, message, Modal, Radio, Row } from "antd";
import Style from "./index.module.scss";
import React, { useContext, useImperativeHandle, useState } from "react";
import Form, { useForm } from "rc-field-form";
import "../../../../../style/public.scss";
import ChapterSelect from "../../../../../components/ChapterSelect";
import { Can, errorMessage } from "../../../../../service/service";
import { ResultMessage } from "../../../../../components/ResultMessage";
import FieldWithError from "../../../../../components/FieldWithError";
import { RowProps } from "antd/es/grid";
import GoChapter from "../GoChapter";
import {
    addCoursewareSourceForOtherCourseware,
    addResProps
} from "../../../../../service/CourseDetail/resource";
import { CourseContext } from "../../../Store";
import useCurrentDate from "../../../../../utils/useCurrentDate";
import useRequestFn from "../../../../../utils/useRequestFn";
import ResourcePool from "../../../../ResourcePool/pages/Index";
import classNames from "classnames";

interface DataModalInstance {
    setPayload: (payload: any) => void;
}

interface DataModalProps extends ModalProps {
    onOk?: () => void;
    onCancel?: () => void;
    onSuccess: () => void;
}

const RowAttr: RowProps = {
    gutter: 15,
    type: "flex",
    align: "middle",
    className: Style.row
};

interface FormProp {
    chapterId: string;
    isPublish: Can;
    description: string;
}

const width = {
    1: 610,
    2: "98%"
};

const HrefModal = React.forwardRef<DataModalInstance, DataModalProps>(
    ({ onSuccess, onOk, onCancel, ...props }, ref) => {
        const [payload, setPayload] = useState({});
        useImperativeHandle(ref, () => ({
            setPayload: payload => {
                setPayload(payload);
            }
        }));
        const [form] = useForm<FormProp>();
        const { course } = useContext(CourseContext);
        const { batchNo } = useCurrentDate();

        const [checkItem, setCheckItem] = useState<React.Key[]>([]);

        const [resAction, { loading }] = useRequestFn(
            addCoursewareSourceForOtherCourseware
        );

        async function onFinish(data: FormProp) {
            try {
                const params: addResProps = {
                    sourceIds: checkItem,
                    batchNo,
                    chapterId: data.chapterId,
                    courseNo: course.courseNo,
                    courseSeq: course.courseSeq,
                    isPublish: data.isPublish,
                    weektimeId: course.weekTimeId,
                    description: data.description
                };
                resAction(params).then(res => {
                    message.success("从资源库添加成功");
                    onSuccess();
                });
            } catch (e) {
                ResultMessage.error(errorMessage(e));
            }
        }

        const [step, setStep] = useState(1);

        return (
            <Modal
                {...props}
                width={width[step as keyof typeof width]}
                centered={step > 1}
                onCancel={onCancel}
                maskClosable={false}
                title="从资源库选择"
                onOk={form.submit}
                footer={
                    <Row type="flex" align="middle" justify="space-between">
                        <Col>
                            {step > 1 && (
                                <span>已选择: {checkItem.length} 个</span>
                            )}
                        </Col>
                        <Col>
                            <div className={Style.footer}>
                                <Button onClick={onCancel}>取消</Button>
                                {step === 1 && (
                                    <Button
                                        type="primary"
                                        onClick={() => {
                                            setStep(step + 1);
                                        }}>
                                        下一步
                                    </Button>
                                )}
                                {step > 1 && (
                                    <>
                                        <Button
                                            onClick={() => {
                                                setStep(step - 1);
                                            }}>
                                            上一步
                                        </Button>
                                        <Button
                                            loading={loading}
                                            type="primary"
                                            disabled={checkItem.length === 0}
                                            onClick={form.submit}>
                                            确认添加
                                        </Button>
                                    </>
                                )}
                            </div>
                        </Col>
                    </Row>
                }>
                <div className={Style.root}>
                    <Form
                        form={form}
                        onFinish={onFinish}
                        style={{ display: step === 2 ? "none" : "" }}>
                        <Row {...RowAttr}>
                            <Col span={5}>
                                <div className={Style.label}>发布设置：</div>
                            </Col>
                            <Col span={16}>
                                <FieldWithError
                                    preserve
                                    name="isPublish"
                                    initialValue={Can.no}>
                                    <Radio.Group>
                                        <Radio value={Can.no}>
                                            仅上传暂不发布
                                        </Radio>
                                        <Radio value={Can.yes}>
                                            上传并立即发布
                                        </Radio>
                                    </Radio.Group>
                                </FieldWithError>
                            </Col>
                        </Row>
                        <Row {...RowAttr}>
                            <Col span={5}>
                                <div className={Style.label}>所属章节：</div>
                            </Col>
                            <Col span={16}>
                                <FieldWithError
                                    name="chapterId"
                                    initialValue="0">
                                    <ChapterSelect />
                                </FieldWithError>
                            </Col>
                            <Col span={1}>
                                <GoChapter />
                            </Col>
                        </Row>
                        <Row {...RowAttr} align="top">
                            <Col span={5}>
                                <div
                                    className={classNames(
                                        Style.label,
                                        "label32"
                                    )}>
                                    课件说明：
                                </div>
                            </Col>
                            <Col span={16}>
                                <FieldWithError
                                    name="description"
                                    initialValue="">
                                    <Input.TextArea
                                        rows={4}
                                        maxLength={500}
                                        placeholder="输入课件说明，最多500字"
                                    />
                                </FieldWithError>
                            </Col>
                        </Row>
                    </Form>
                    {step === 2 && (
                        <ResourcePool onCheck={setCheckItem} show="window" />
                    )}
                </div>
            </Modal>
        );
    }
);

export default HrefModal;
